import { Flex, Skeleton } from "antd"

import { ReceiptProgramCard } from "./ReceiptProgramCard"

import styles from "./styles.module.less"

const SKELETON_COUNT = 3

export const ProgramCardsRow = ({ cards, loading, selectedProgram, onSelect }) => (
  <Flex gap={24} className={styles.selector}>
    {loading
      ? Array.from({ length: SKELETON_COUNT }, (_, i) => (
          <Flex key={i} vertical justify="center" className={styles.card}>
            <Skeleton.Node active size="small" className={styles.skeletonName} />
            <Flex justify="space-between" align="flex-end">
              <Skeleton.Node active size="large" className={styles.skeletonValue} />
              <Skeleton.Node active size="small" className={styles.skeletonChip} />
            </Flex>
          </Flex>
        ))
      : cards.map((c) => (
          <ReceiptProgramCard
            key={c.id}
            {...c}
            isActive={selectedProgram === c.id}
            onClick={onSelect}
          />
        ))}
  </Flex>
)
